import React from 'react';
import EditButton from '../../../components/ui/EditButton';
import { getEligibleBespokeModuleGroups, normalizeTeamMetadata } from '../utils/teamMetadata';
import {
  enabledAtPath,
  getModuleSections,
} from '../utils/moduleUtils';

export default function ModulesCard({ modules = {}, metadata = {}, onEdit }) {
  const eligibleBespokeGroups = getEligibleBespokeModuleGroups(metadata);
  const hasSelectedMetadataLabels = normalizeTeamMetadata(metadata).labels.length > 0;
  const sections = getModuleSections(eligibleBespokeGroups);

  const isEnabled = (path, legacyPath) => {
    if (path && enabledAtPath(modules, path)) return true;
    if (legacyPath && enabledAtPath(modules, legacyPath)) return true;
    return false;
  };

  const countEnabled = (items, predicate) =>
    items.reduce((total, item) => total + (predicate(item) ? 1 : 0), 0);

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Enabled Modules</span>
        <EditButton section="modules" onEdit={onEdit} />
      </div>

      <div className="card-body modules-card__body">
        {sections.map(({ key, title, items }) => (
          <div key={key} className="module-group">
            <details>
              <summary className="card-title" style={{ cursor: 'pointer' }}>
                {title} ({countEnabled(items, (item) => isEnabled(item.path, item.legacyPath))}/{items.length} enabled)
              </summary>
              <div style={{ marginTop: '0.5rem' }}>
                {items.map(({ path, legacyPath, label, description }) => {
                  const id = path.join('.');
                  return (
                    <div key={id} className="module-toggle mb-3">
                      <div>
                        <strong>{label}</strong>: {isEnabled(path, legacyPath) ? '✅ Enabled' : '❌ Disabled'}
                      </div>
                      <div className="text-muted" style={{ fontSize: '0.9rem' }}>{description}</div>
                    </div>
                  );
                })}
              </div>
            </details>
          </div>
        ))}

        {!hasSelectedMetadataLabels && eligibleBespokeGroups.length === 0 && (
          <p className="text-muted" style={{ marginTop: '0.75rem', fontSize: '0.9rem' }}>
            Select club categories or types in <strong>Club Details</strong> to reveal eligible bespoke modules.
          </p>
        )}
      </div>
    </div>
  );
}
